export const NAV_HEIGHT = 105;

// Extra margin to give sections when users click a navigation tab to scroll
export const CLICK_MARGIN = 4;
